BX = window.BX || {};

// BX.showWait = () => $(window).trigger('preloader:show');
// BX.hideHide = () => $(window).trigger('preloader:hide');

jQuery.fn.extend({
    scrollTo: function (offset, time, dst) {
        time = time || 600;
        offset = offset || 0;
        dst = dst || this.offset().top + offset;
        if (dst)
            $("html,body").animate({scrollTop: dst}, time);
        return this;
    }
});

$('button').on('click', function () {
   if ($(this).data('layout-price')){
       $('input[data-layout-price]').val($(this).data('layout-price'));
   }
    if ($(this).data('layout-area')){
        $('input[data-layout-area]').val($(this).data('layout-area'));
    }
    if ($(this).data('layout-rooms')){
        $('input[data-layout-rooms]').val($(this).data('layout-rooms'));
    }
});

// $(document).on('click', 'button[type="submit"]', function() {
//     var today_day = null;
//     var time = $('#time').val();
//     if (!!time){
//         today = new Date(); var dd = today.getDate(); var mm = today.getMonth() + 1; var yyyy = today.getFullYear();
//         if (dd < 10) { dd = '0' + dd; } if (mm < 10) { mm = '0' + mm; }
//         today_day = yyyy + '-' + mm + '-' + dd + ' ' + time + ':00';
//     }
//     var phone_ct = $(this).closest('form').find('input[type*="tel"]').val();
//     phone_ct = phone_ct.replace(/[^0-9]/gim, '');
//     if (phone_ct!=''){
//         if (phone_ct[0] == '7') {phone_ct=phone_ct.substring(1);}
//         if (phone_ct[0] == '8') {phone_ct=phone_ct.substring(1);}
//         phone_ct= '7' +phone_ct;
//     };
//     if (!!phone_ct){
//         window.ctw.createRequest('def-1', phone_ct, [], function(success, data){ console.log(success, data) } , today_day );
//     };
// });